const colors = {
  Red: "#dc3545",
  White: "#ffffff",
  Black: "#000000",
  Black20: "rgba(0, 0, 0, 0.5)",
  TransparentBlack: "#000000d0",
  TransparentWhite: "rgba(255, 255, 255, 0.50)",

  BasicGreen: "#00D952",
  DarkGreen: "#008332",
  
  Gray20: "#5D6371",
  Gray40: "#9096A3",
  Gray60: "#B7BDC8",
  Gray80: "#dfdfdf",
  Gray100: "#F0F0F0",
  Gray120: "#fafafa"
};

export default colors;